import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

// checks if user is authorized to see a page.
const Authenticated = (props) => {
  const user = useSelector((state) => state.auth.user);
  let history = useHistory();

  const checkAuthentication = () => {
    if (user._id) {
      history.push("/admin/products");
    } else {
      return null;
    }
  };

  useEffect(() => {
    checkAuthentication(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return props.render();
};

export default Authenticated;
